import { render, staticRenderFns } from "./VerboseOrderView.vue?vue&type=template&id=4a1c787d"
import script from "./VerboseOrderView.vue?vue&type=script&lang=js"
export * from "./VerboseOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports